import { element$ } from './element';
import { ElementOptions } from './element.options';

type ElementType = HTMLSpanElement;
export type SpanElementOptions = ElementOptions<ElementType> & {};
type Options = SpanElementOptions;

export function span$(): ElementType;
export function span$(classes: string): ElementType;
export function span$(classes: string, children: Element[]): ElementType;
export function span$(classes: string, options: Options): ElementType;
export function span$(
  classes: string,
  options: Options,
  children: Element[]
): ElementType;
export function span$(children: Element[]): ElementType;
export function span$(options: Options): ElementType;
export function span$(options: Options, children: Element[]): ElementType;
export function span$(
  arg1?: Options | Element[] | string,
  arg2?: Options | Element[],
  arg3?: Element[]
): ElementType {
  return element$('span', arg1, arg2, arg3);
}
